interface IProps {
  color: string;
}

export const AiBackIcon = ({ color }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.757836 3.47574C0.0789904 4.80757 0.0787414 6.55117 0.0782378 10.0384L0.077067 18.1329C0.0765653 21.6201 0.0763164 23.3637 0.754777 24.6957C1.35157 25.8674 2.30397 26.8201 3.47548 27.4172C4.80732 28.096 6.55091 28.0963 10.0381 28.0968L18.1326 28.098C21.6198 28.0985 23.3634 28.0987 24.6954 27.4202C25.8671 26.8235 26.8198 25.8711 27.4169 24.6995C28.0958 23.3677 28.096 21.6241 28.0965 18.1369L28.0977 10.0424C28.0982 6.55521 28.0985 4.81161 27.42 3.47958C26.8232 2.3079 25.8708 1.35522 24.6993 0.758088C23.3675 0.0792421 21.6239 0.0789932 18.1367 0.0784895L10.0421 0.0773188C6.55496 0.0768171 4.81136 0.0765681 3.47933 0.755028C2.30764 1.35182 1.35497 2.30422 0.757836 3.47574ZM16.7452 10.5188C17.3532 9.911 17.3534 8.92539 16.7456 8.3174C16.1377 7.70941 15.1521 7.70927 14.5441 8.31708L9.87356 12.9863C9.26557 13.5941 9.26543 14.5797 9.87324 15.1877L14.5425 19.8583C15.1503 20.4663 16.1359 20.4665 16.7439 19.8586C17.3519 19.2508 17.352 18.2652 16.7442 17.6572L13.1755 14.0875L16.7452 10.5188Z"
        fill={color}
      />
    </svg>
  );
};
